export default "__VITE_ASSET__40f46a3a__"